import React, { Component } from 'react';
import Button, { ButtonGroup } from '@atlaskit/button';
import { CampaignFields } from './components/CampaignForm';
import { FormFooter } from '@atlaskit/form';
import { Grid, GridColumn } from '@atlaskit/page';
import { withTranslation, Trans } from 'react-i18next';
import ContentWrapper from '../../components/ContentWrapper';
import { connect } from 'react-redux';
import CampaignActions from '../../redux/CampaignRedux';
import DictionariesActions from '../../redux/DictionariesRedux';
import FirmwaresActions from '../../redux/FirmwaresRedux'
import dateFormat from 'dateformat';
import { convertLocalToUtc, addDays } from '../../helpers/dateHelper';

class CreateCampaignPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      campaign: {
        name: '',
        startDateTime: addDays(Date.now(), 1),
        endDateTime: addDays(Date.now(), 2),
        firmware: null,
        firmwareId: null,
        toFactory: false,
      },
      rules: [],
      cars: [],
      notFoundCarVins: [],
      textVins: '',
      parsedVins: [],
      firmwares: [],
      file: null,
      errors: {},
    };
  }

  componentDidMount() {
    this.props.getDictionaries('firmwares');
    this.props.getDictionaries('fotafields');
  }

  componentDidUpdate(prevProps) {
    const { history, fetching, fetchingCars, campaign, cars } = this.props;

    if (prevProps.fetchingCars && !fetchingCars && !this.props.error) {
      this.setState({
        cars: cars
      });
    }

    if (prevProps.fetching !== fetching &&
      prevProps.fetching &&
      !this.props.error &&
      campaign && campaign.id) {
      history.goBack();
    }
  }

  onCancel = e => {
    e.preventDefault();
    this.props.history.goBack();
  };

  onFormSubmit = e => {
    e.preventDefault();
    const { create, cars } = this.props;
    const { campaign, rules } = this.state;


    const errors = this.validateForm();
    this.setState({ errors: errors });

    if (Object.keys(errors).length > 0)
      return;

    const firmwareId = campaign.firmware?.id;

    const carIds = cars.map(c => c.id)
    campaign.startDateTime = dateFormat(campaign.startDateTime, 'isoUtcDateTime');
    campaign.endDateTime = dateFormat(campaign.endDateTime, 'isoUtcDateTime');

    create({ ...campaign, filterRules: rules, carIds, firmwareId: firmwareId });
  };

  validateForm = () => {
    const { campaign, cars } = this.state;
    const { t } = this.props;
    const errors = {};

    if (campaign && !campaign.firmware && !campaign.toFactory) {
      errors.firmware = `${t('Firmware')} ${t('Is required')}`;
    }
    if (cars && !cars.length) {
      errors.cars = `${t('Car filter')} ${t('Is required')}`;
    }

    const startDateTime = new Date(campaign.startDateTime).getTime();
    const endDateTime = new Date(campaign.endDateTime).getTime();

    if (startDateTime >= endDateTime) {
       errors.dateEndLess = `${t('End date less than start date')}`;
    }

    return errors;
  };

  onFileChange = file => {
    this.setState({ cars: [], rules: [] });
    this.props.uploadVinListFile(this.state?.campaign?.firmware?.id, file);
  };

  onParseVinText = e => {
    this.setState({ cars: [], rules: [] });
    this.props.uploadParsedVins(this.state.campaign?.firmware?.id, this.state.parsedVins);
  }

  onCarsFilter = e => {
    this.setState({ cars: [] });
    this.props.uploadCarsFilter(this.state.campaign?.firmware?.id, this.state.rules);
  }

  onChange = (name, value) => {
    if (name === 'rules') {
      this.setState({ rules: value });
    } else if (name === 'textVins') {
      const splitedText = value.split('\n');
      this.setState({ textVins: value, parsedVins: splitedText });
    } else if (name === 'toFactory') {

      this.setState(prevState => ({
        campaign: {
          ...prevState.campaign,
          toFactory: value,
        }
      }));
      
      if (value) {
        this.setState(prevState => ({
          campaign: {
            ...prevState.campaign,
            firmware: null,
          }
        }));
      } 
    } else if (name === 'firmware') {
      this.setState(prevState => ({
        campaign: {
          ...prevState.campaign,
          firmware: value,
          toFactory: false,
        }
      }));
    }
    else {
      this.setState(prevState => ({
        campaign: { ...prevState.campaign, [name]: value || '' },
      }));
    }
  };

  render() {
    const { campaign, file, rules, firmwares, errors, cars, textVins, parsedVins } = this.state;
    const { fetching, dictionaries, getDictionaries, t, notFoundCarVins, fetchingCars } = this.props;

    return (
      <ContentWrapper>
        <h1>{t('Create New Campaign')}</h1>
        <form onSubmit={this.onFormSubmit}>
          <Grid>
            <CampaignFields
              campaign={campaign}
              file={file}
              onChange={this.onChange}
              onFileChange={this.onFileChange}
              onParseVinText={this.onParseVinText}
              onCarsFilter={this.onCarsFilter}
              dictionaries={dictionaries}
              getDictionaries={getDictionaries}
              fetchingCars={fetchingCars}
              fetching={fetching}
              rules={rules}
              t={t}
              cars={cars}
              notFoundCarVins={notFoundCarVins}
              firmwares={firmwares}
              errors={errors}
              textVins={textVins}
              parsedVins={parsedVins}
            />
            <GridColumn>
              <FormFooter>
                <ButtonGroup>
                  <Button appearance='subtle' isDisabled={fetching} onClick={this.onCancel}>
                    <Trans>Cancel</Trans>
                  </Button>
                  <Button type='submit' isDisabled={fetching} isLoading={fetching} appearance='primary'>
                    <Trans>Create</Trans>
                  </Button>
                </ButtonGroup>
              </FormFooter>
            </GridColumn>
          </Grid>
        </form>
      </ContentWrapper>
    );
  }
}

const mapStateToProps = state => {
  return {
    permissions: state.userProfile.permissions.campaigns,
    fetching: state.campaign.fetching,
    campaign: state.campaign.campaign,
    fetchingCars: state.campaign.fetchingCars,
    error: state.campaign.error,
    dictionaries: state.dictionaries,
    cars: state.campaign.cars,
    notFoundCarVins: state.campaign.notFoundCarVins,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    create: data => dispatch(CampaignActions.createCampaignRequest(data)),
    uploadVinListFile: (id, file) => dispatch(CampaignActions.uploadVinFileRequest(id, file)),
    uploadParsedVins: (id, vins) => dispatch(CampaignActions.uploadParsedVinsRequest(id, vins)),
    uploadCarsFilter: (id, rules) => dispatch(CampaignActions.uploadCarsFilterRequest(id, rules)),
    getDictionaries: name => dispatch(DictionariesActions.dictionariesRequest(name)),
    fetchFirmwares: params => dispatch(FirmwaresActions.firmwaresRequest(params))
  };
};

export default withTranslation('fota')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(CreateCampaignPage),
);